module.exports = __webpack_public_path__ + "static/img/yiti_05.931ef72c.jpg";